var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSportsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3392",
    "data-name": "Group 3392",
    transform: "translate(-72 -3032)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_316",
    "data-name": "Ellipse 316",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(72 3032)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3396",
    "data-name": "Group 3396",
    transform: "translate(83.203 3042.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4752",
    "data-name": "Path 4752",
    d: "M-473.615,255.541l-1.34,1.686c.485.544.977,1.081,1.453,1.633a7.082,7.082,0,0,1,1.786,4.492c.04,1.211.083,2.424.063,3.635a1.83,1.83,0,0,1-1.758,1.781,1.886,1.886,0,0,1-1.936-1.452,2.856,2.856,0,0,1-.05-.616c-.016-.946-.03-1.892-.036-2.839a4.161,4.161,0,0,0-1.213-2.926c-.21-.221-.421-.441-.652-.683-.17.208-.325.405-.489.6a9.421,9.421,0,0,1-5.736,3.137,19.618,19.618,0,0,1-4.392.181,1.85,1.85,0,0,1-1.682-1.79,1.819,1.819,0,0,1,1.584-1.927c.9-.066,1.813-.032,2.719-.072a14.011,14.011,0,0,0,1.583-.167,2.3,2.3,0,0,0,1.8-1.335,23.04,23.04,0,0,0,.907-2.238c.384-1.1.719-2.226,1.073-3.341.026-.081.041-.164.071-.284a9.273,9.273,0,0,0-2.3.607c-.455.184-.9.4-1.338.618a1.9,1.9,0,0,1-2.592-.779,1.887,1.887,0,0,1,.833-2.571,13.772,13.772,0,0,1,5.163-1.666,10.212,10.212,0,0,1,8.183,2.7,16.073,16.073,0,0,0,1.876,1.52,3.84,3.84,0,0,0,2.912.411,1.894,1.894,0,0,1,2.254,1.455,1.873,1.873,0,0,1-1.485,2.233,7.914,7.914,0,0,1-7.046-1.826C-473.467,255.66-473.535,255.606-473.615,255.541Z",
    transform: "translate(489.597 -240.383)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4753",
    "data-name": "Path 4753",
    d: "M-266.086,105.125a4.259,4.259,0,0,1-4.277,4.249,4.246,4.246,0,0,1-4.223-4.295,4.244,4.244,0,0,1,4.269-4.219A4.26,4.26,0,0,1-266.086,105.125Z",
    transform: "translate(287.309 -100.86)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4754",
    "data-name": "Path 4754",
    d: "M-128.187,472.172a3.3,3.3,0,0,1-3.294,3.315,3.309,3.309,0,0,1-3.306-3.306,3.307,3.307,0,0,1,3.3-3.314A3.3,3.3,0,0,1-128.187,472.172Z",
    transform: "translate(155.781 -447.092)",
    fill: "#febaba"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsicon);
export default __webpack_public_path__ + "static/media/sportsicon.c5abcdf280175fb28eea79ec9ce2d0d6.svg";
export { ForwardRef as ReactComponent };